import React from 'react'
import { Table, CustomInput } from 'reactstrap'
import ReactList from 'react-list'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import shortid from 'shortid'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'
import { FONTS, COLORS } from '../../constants'

// const header = [{ label: 'Employee ID', value: 0 }, { label: 'Company Name', value: 1 }, { label: 'LOB', value: 2 }, { label: 'Employee Name', value: 3 }, { label: 'Nickname', value: 4 }, { label: 'Position', value: 5 }]
const header = [{ label: '', value: 4 }, { label: 'Name', value: 1 }, { label: 'LOB', value: 2 }, { label: 'Type', value: 3 }]

export default class CustomTableEmployeeCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isGoing: false,
      numberOfGuests: 2,
      checked: false,
  }
  // this.handleInputChange = this.handleInputChange.bind(this);
}
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'users')) !== JSON.stringify(prevState.users)) {
      let list = get(nextProps, 'users').filter((user) => { return !user.is_init_user })
      switch (prevState.sort_column) {
        case 0: {
          list = orderBy(list, 'emp_code', 'asc')
          break
        }
        case 1: {
          list = orderBy(list, 'company', 'asc')
          break
        }
        case 2: {
          list = orderBy(list, 'lob', 'asc')
          break
        }
        case 3: {
          list = orderBy(list, 'name', 'asc')
          break
        }
        case 4: {
          list = orderBy(list, 'nick_name', 'asc')
          break
        }
        case 5: {
          list = orderBy(list, 'position', 'asc')
          break
        }
        default: break
      }
      set(tempState, 'users', get(nextProps, 'users'))
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: true,
    sort_column: 0,
    users: [],
    items: [],
    isChecked: false,
  }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state }
    const { users } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    switch (column) {
      case 0: {
        const newItems = orderBy(users, 'emp_code', sort_order)
        return this.setState({ items: newItems })
      }
      case 1: {
        const newItems = orderBy(users, 'company', sort_order)
        return this.setState({ items: newItems })
      }
      case 2: {
        const newItems = orderBy(users, 'lob', sort_order)
        return this.setState({ items: newItems })
      }
      case 3: {
        const newItems = orderBy(users, 'name', sort_order)
        return this.setState({ items: newItems })
      }
      case 4: {
        const newItems = orderBy(users, 'nick_name', sort_order)
        return this.setState({ items: newItems })
      }
      case 5: {
        const newItems = orderBy(users, 'position', sort_order)
        return this.setState({ items: newItems })
      }
      default: return users
    }
  }
  renderItem = (index, key) => {
    const data = this.state.items[index]
    const rowID = get(this.props, 'rowID')
    const lob = find(this.props.masterData.lobs, {
        _id: data.lob_id,
      })
      const newEmployee = {}
      newEmployee._id = data._id
      newEmployee.emp_code = data.emp_code
      newEmployee.name = `${data.first_name} ${data.last_name}`
      newEmployee.nick_name = data.nick_name
      newEmployee.lob = lob ? lob.name : '-'
      newEmployee.type = data.employee_type
      
      const array_employee_id = get(this.props, 'employee_id')
      return (
      <tr
        key={ shortid() }
        style={ {
          hover: '#E5E5E5',
          backgroundColor: key === rowID ? '#E5E5E5' : '',
        } }
        //onClick={ () => get(this.props, 'clickRow')(key, data._id) }
      >
        <td  style={ {width: '10%'}}>
        <center>
        <CustomCheckboxInput
                  id={ shortid() }
                  type="checkbox"
                  name={ newEmployee._id }
                  value={ newEmployee._id }
                  onChange={ (e) => this.props.handleInputChange(e, newEmployee._id)}
                  checked={ array_employee_id.includes(newEmployee._id) }
          /></center>
        </td>
        <td>{ newEmployee.emp_code + '-' + newEmployee.name }
        <br></br>({ newEmployee.nick_name })
        </td>
        <td>{ newEmployee.lob }</td>
        <td>{ newEmployee.type }</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state
    
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <CustomTable bordered hover>
          <BodyTable>
            <Header>
              <tr>
                {
                  header.map((h) =>
                    (<Head key={ shortid() } onClick={ () => this.handleClickSort(h.value) } style={h.value === 4 ? {width:'10%'} : {}}>
                      { h.label }
                      { h.value === sort_column && (
                        sort_order && h.value === sort_column ?
                          <Icon src={ arrow_up } alt="logo" />
                          :
                          <Icon src={ arrow_down } alt="logo" />
                      )
                      }
                     
                    </Head>)
                  )
                }
              </tr>
            </Header>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </CustomTable>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const BodyTable = styled.tbody`
  display: block;
  max-height: calc(100vh - 135px);
  overflow-y:scroll;
`
const CustomTable = styled(Table)`
  background: white;
  thead{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE}
  }
`
const Head = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  position: sticky;
  z-index: 1000;
  top: 0;

  background: ${COLORS.TABLE_HEADER_COLOR};

  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.TITLE_SIZE};
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const CustomCheckboxInput = styled(CustomInput)`
  font-family: 'Gotham' !important;
  font-size: 12px;
`



// WEBPACK FOOTER //
// ./src/components/table-employee-checkbox/index.js